import { Component, inject } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseViewComponent } from '../base-view.component';
import { StateChangedModel } from '../../common/services/state.service';
import { SecureDataService } from '../../common/services/securedata.sevice';
import { LanguageStateService } from '../../common/services/language-state.service';
import { take } from 'rxjs';


export interface QuestionAnswerRequest {
  QuestionId: number
  QuestionText: string;
  CreditAnswers: {
    CreditAnswer: {
      AnswerId: number;
      AnswerText: string;
    }[]
  }
}

@Component({
    selector: 'app-ncvc-questionnaire',
    templateUrl: './ncvc-questionnaire.component.html',
    styleUrl: './ncvc-questionnaire.component.scss',
    standalone: false
})
export class NcvcQuestionnaireComponent extends BaseViewComponent {
  questionAnswers: { questionId: number, answerId: number }[] = [];
  questionData: QuestionAnswerRequest[] = [];
  isSubmitted: boolean;
  showCancelDialog = false;
  #secureDataService: SecureDataService = inject(SecureDataService);
  languageService: LanguageStateService = inject(LanguageStateService)

  protected override onSecureDataChanged(val: StateChangedModel): void {
    if (val) {
      this.questionData = (val.Data as any)?.questionData as QuestionAnswerRequest[];

      this.questionnaireForm = this.fb.group({
        answers: this.fb.array([], Validators.required) // Initialize an empty FormArray
      });

      this.buildForm();

    }

  }

  fb: FormBuilder = inject(FormBuilder)
  questionnaireForm: FormGroup = this.fb.group({
    answers: this.fb.array([], Validators.required)
  });


  // Build the form dynamically based on questions data
  private buildForm() {
    const answersArray = this.questionnaireForm.get('answers') as FormArray;
    this.questionData?.forEach((value) => {
      this.questionAnswers.push({ questionId: value.QuestionId, answerId: 0 })
      answersArray.push(this.fb.control('', Validators.compose([Validators.required, Validators.minLength(1)]))); // Create a control for each question's answer
    });
  }



  updateFormControl(event: any, index: number) {
    const selectedValue = event.value;
    (<FormArray>this.questionnaireForm.get('answers')).at(index).patchValue(selectedValue);
  }

  requiredFieldValidation(i: number) {
    return (this.questionnaireForm.get('answers') as FormArray).at(i).invalid &&
      ((this.questionnaireForm.get('answers') as FormArray).at(i).dirty ||
        (this.questionnaireForm.get('answers') as FormArray).at(i).touched);
  }

  onFormSubmit() {
    this.questionnaireForm.markAllAsTouched();
    this.isSubmitted = true;
    if (this.questionnaireForm.invalid) {
      return;
    }

    if (this.questionnaireForm.valid) {

      const answersArray = this.questionnaireForm.get('answers') as FormArray;
      for (let i = 0; i < answersArray.length; i++) {
        this.questionAnswers[i].answerId = answersArray.at(i).value;
      }

      this.#secureDataService.submitCustomerData(this.questionAnswers, 'NCVCQuestionnaire')
        .subscribe({
          next: () => {
            this.navigateWaiting();
          },
          error: (err) => {
            this.notificationService.showError(err);
          }
        });
    }

  }

  onFormCancel() {
    this.showCancelDialog = true;
    this.isSubmitted = false;
  }

  onCancelConfimation(data: unknown) {
      this.showCancelDialog = false;
  
      if (data && (data as { data: { success: boolean } }).data?.success) {
        this.questionnaireForm?.reset();
        this.#secureDataService.cancel('NCVCQuestionnaire').pipe(take(1)).subscribe(
          {
            next: () => {
              this.navigateWaiting(true);
            },
            error: (err) => this.onCancelError('NCVCQuestionnaire', err)
          })
      }
    }
}
